import { useMemo, useRef, type ReactNode } from 'react'
import { NavigationGuardContext, type NavigationGuard } from './NavigationGuardContext'

export const NavigationGuardProvider = ({ children }: { children: ReactNode }) => {
  const guardRef = useRef<NavigationGuard | null>(null)
  const value = useMemo(() => ({ guardRef }), [])
  return <NavigationGuardContext.Provider value={value}>{children}</NavigationGuardContext.Provider>
}
